import React from 'react';
import CategoryPage from '../components/CategoryPage';
import { fashionFilmProjects } from '../data/mock';
import { Film } from 'lucide-react';

const FashionFilm = () => (
  <CategoryPage
    icon={Film}
    title="Fashion Film"
    subtitle="Estética · Direção de Arte · Color Grading. Narrativas visuais para marcas de moda — da direção criativa à finalização de cor."
    projects={fashionFilmProjects}
    tapeColor="rgba(210,190,130,0.42)"
    tapeSide="left"
  />
);

export default FashionFilm;
